var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var DrawingStateMachine = require("./../../../abstract/stateMachines/drawingStateMachine.js");

var TriangleToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options) {
    this.root = root;
    this.getDataCollection = getDataCollection;
    this.options = options;

    DrawingStateMachine.call(this, root, editorModel, selectionModel);
};
lib_core.inherit(TriangleToolStateMachine, DrawingStateMachine);

module.exports = TriangleToolStateMachine;

TriangleToolStateMachine.prototype.createElement = function () {
    var triangle = new cio_datamodel.TriangleData(this.startCoord,
            this.options.angle, 0, 0, this.options.fill, this.options.strokeWidth);

    triangle.addTo(this.getDataCollection());

    return this.getElementInteractionModel(triangle);
};
